import { EnvironmentModel } from "./environment.model";

export const environment: EnvironmentModel = {
    CONTENTFUL_SPACE: 'hnn1d2d2w1nl',
    CONTENTFUL_ACCESS_TOKEN: 'QQLVQuonrg3-JjNefFzgimWguy3rKXlzWiykFbN_kl4',
    CONTENTFUL_EVENTS: '7FPSFvOrgDnvi2xz3mwU9h',
    SIGN_IN_URL: 'https://test-portal.gurokonekt.com/login',
    REGISTER_URL: 'https://test-portal.gurokonekt.com/login',
    API_URL: 'https://test-api.gurokonekt.com/api',
    RECAPTCHA_SITE_KEY: '6LcyYXstAAAAADjPzli4ry2bgHPFb9KG3MTpoDuF',
};
